import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import React, { useEffect, useState } from "react";

import API from "../../utils/API";
import { Edit2 } from "react-feather";
import LenderTitle from "../../components/fields/LenderTitle";
import Loader from "../../components/Loader";
import Order from "../../components/fields/Order";
import OrderStatus from "../../components/status/OrderStatus";
import Pagination from "../../components/Pagination";
import Product from "../../components/fields/Product";
import { parseFilterValues } from "../../utils/helpers/filterHelper";
import { useHistory } from "react-router-dom";
import SortDirection from "../../components/SortDirection";
import LenderSelect from "../../components/formfields/LenderSelect";
import MutualExclusivityTypeSelect from "../../components/formfields/MutualExclusivityTypeSelect";
import MutualExclusivityType from "../../components/fields/MutualExclusivityType";

const MutualExclusivityReport = () => {
    let history = useHistory();

    const defaultFiltrationState = {
        page: 1,
        perPage: 100,
    };

    const urlParams = new URLSearchParams(history.location.search);
    const parsedParams = Object.fromEntries(urlParams.entries());
    const filtersParsed = parseFilterValues(parsedParams);

    const [filtration, setFiltration] = useState({
        ...defaultFiltrationState,
        ...filtersParsed,
    });

    const [data, setData] = useState(null);
    const [items, setItems] = useState(null);
    const [loading, setLoading] = useState(true);

    const changeData = (name, value) => {
        setFiltration({ ...filtration, [name]: value });

        history.push({
            pathname: history.location.pathname,
            search: new URLSearchParams({ ...filtration, [name]: value }).toString(),
        });
    };

    const changeNativeData = (e) => {
        setFiltration({ ...filtration, [e.target.name]: e.target.value });

        history.push({
            pathname: history.location.pathname,
            search: new URLSearchParams({
                ...filtration,
                [e.target.name]: e.target.value,
            }).toString(),
        });
    };

    useEffect(() => {
        setLoading(true);
        API.post("/admin/lender/mutualexclusivity", filtration).then((response) => {
            setItems(response.data.data.data);
            setData(response.data.data);
            setLoading(false);
        });
    }, [filtration]);

    return (
        <Container fluid className="p-0">
            <div className="row justify-content-between">
                <div className="col-auto">
                    <h3 className="h3 mb-3 float-left">Mutual exclusivity report</h3>
                </div>
            </div>
            <Row form>
                <Col md={2}>
                    <LenderSelect
                        name={"lender"}
                        onChange={changeData}
                        value={filtration?.lender}
                    />
                </Col>
                <Col md={2}>
                    <MutualExclusivityTypeSelect
                        name={"type"}
                        onChange={changeNativeData}
                        value={filtration?.type}
                    />
                </Col>
            </Row>
            <Row className="mt-2">
                <Col>
                    {loading && <Loader />}
                    <Card>
                        {!loading && items && items.length > 0 ? (
                            <div className="table-responsive">
                                <Table>
                                    <thead>
                                    <tr>
                                        <th>Lender<SortDirection fieldName={'title'} filters={filtration} changeFilter={changeData}/></th>
                                        <th>Type<SortDirection fieldName={'type'} filters={filtration} changeFilter={changeData}/></th>
                                        <th>Exclusivity list</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {items.map((item) => {
                                        return (
                                            <tr key={item.id}>
                                                <td><LenderTitle title={item.lender.title} id={item.lender.id}/></td>
                                                <td>
                                                    <MutualExclusivityType type={item.filter}/>
                                                </td>
                                                <td>
                                                    {item.filterdata.map((filterdataItem) => {
                                                        return <div key={filterdataItem.id}><LenderTitle title={filterdataItem.title} id={filterdataItem.id}/></div>
                                                    })}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </Table>
                            </div>
                        ) : (
                            !loading && (
                                <CardBody className="text-center">
                                    <h5>Data not found</h5>
                                </CardBody>
                            )
                        )}
                    </Card>
                    {data?.page > 0 && data?.pages > 0 && (
                        <Pagination
                            onChange={changeData}
                            name={"page"}
                            page={data.page}
                            totalPages={data.pages}
                            loading={loading}
                        />
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default MutualExclusivityReport;
